import React from "react";
import { useTranslation } from "react-i18next";

/* ── Inline SVG illustrations ── */

const TruckSVG = ({ className = "w-32 h-16 text-primary" }) => (
  <svg viewBox="0 0 200 100" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* cargo */}
    <rect x="8" y="22" width="112" height="58" rx="5" fill="currentColor" fillOpacity=".10" stroke="currentColor" strokeOpacity=".25" strokeWidth="1.5"/>
    <line x1="66" y1="22" x2="66" y2="80" stroke="currentColor" strokeOpacity=".18" strokeWidth="1.5"/>
    {/* boxes */}
    <rect x="17" y="32" width="22" height="22" rx="2" fill="currentColor" fillOpacity=".18"/>
    <line x1="28" y1="32" x2="28" y2="54" stroke="currentColor" strokeOpacity=".12" strokeWidth="1"/>
    <line x1="17" y1="43" x2="39" y2="43" stroke="currentColor" strokeOpacity=".12" strokeWidth="1"/>
    <rect x="46" y="32" width="22" height="22" rx="2" fill="currentColor" fillOpacity=".18"/>
    <line x1="57" y1="32" x2="57" y2="54" stroke="currentColor" strokeOpacity=".12" strokeWidth="1"/>
    <line x1="46" y1="43" x2="68" y2="43" stroke="currentColor" strokeOpacity=".12" strokeWidth="1"/>
    <rect x="76" y="32" width="22" height="22" rx="2" fill="currentColor" fillOpacity=".18"/>
    <line x1="87" y1="32" x2="87" y2="54" stroke="currentColor" strokeOpacity=".12" strokeWidth="1"/>
    <line x1="76" y1="43" x2="98" y2="43" stroke="currentColor" strokeOpacity=".12" strokeWidth="1"/>
    {/* cab */}
    <path d="M120 42 L120 80 L178 80 L178 56 L157 32 L120 32 Z" fill="currentColor" fillOpacity=".13" stroke="currentColor" strokeOpacity=".28" strokeWidth="1.5"/>
    {/* window */}
    <path d="M126 46 L126 64 L168 64 L168 57 L150 38 L126 38 Z" fill="currentColor" fillOpacity=".3"/>
    {/* grille */}
    <rect x="170" y="64" width="8" height="12" rx="1" fill="currentColor" fillOpacity=".2"/>
    {/* wheels */}
    <circle cx="38" cy="87" r="11" fill="currentColor" fillOpacity=".18" stroke="currentColor" strokeOpacity=".3" strokeWidth="1.5"/>
    <circle cx="38" cy="87" r="5" fill="currentColor" fillOpacity=".35"/>
    <circle cx="155" cy="87" r="11" fill="currentColor" fillOpacity=".18" stroke="currentColor" strokeOpacity=".3" strokeWidth="1.5"/>
    <circle cx="155" cy="87" r="5" fill="currentColor" fillOpacity=".35"/>
    {/* road */}
    <line x1="0" y1="98" x2="200" y2="98" stroke="currentColor" strokeOpacity=".12" strokeWidth="2" strokeDasharray="12 6"/>
  </svg>
);

const DocumentTruckSVG = ({ className = "w-36 h-20 text-primary" }) => (
  <svg viewBox="0 0 220 110" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* document */}
    <rect x="2" y="8" width="68" height="85" rx="5" fill="currentColor" fillOpacity=".08" stroke="currentColor" strokeOpacity=".2" strokeWidth="1.5"/>
    <line x1="14" y1="28" x2="58" y2="28" stroke="currentColor" strokeOpacity=".2" strokeWidth="2" strokeLinecap="round"/>
    <line x1="14" y1="40" x2="58" y2="40" stroke="currentColor" strokeOpacity=".15" strokeWidth="2" strokeLinecap="round"/>
    <line x1="14" y1="52" x2="45" y2="52" stroke="currentColor" strokeOpacity=".15" strokeWidth="2" strokeLinecap="round"/>
    <line x1="14" y1="64" x2="52" y2="64" stroke="currentColor" strokeOpacity=".15" strokeWidth="2" strokeLinecap="round"/>
    {/* connector arrow */}
    <line x1="72" y1="55" x2="95" y2="55" stroke="currentColor" strokeOpacity=".2" strokeWidth="1.5" strokeDasharray="4 3"/>
    <path d="M92 51 L98 55 L92 59" stroke="currentColor" strokeOpacity=".3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    {/* truck */}
    <g transform="translate(95, 20)">
      <rect x="0" y="8" width="72" height="42" rx="4" fill="currentColor" fillOpacity=".1" stroke="currentColor" strokeOpacity=".22" strokeWidth="1.5"/>
      <path d="M72 22 L72 50 L110 50 L110 34 L95 16 L72 16 Z" fill="currentColor" fillOpacity=".12" stroke="currentColor" strokeOpacity=".25" strokeWidth="1.5"/>
      <path d="M76 26 L76 40 L104 40 L104 35 L91 22 L76 22 Z" fill="currentColor" fillOpacity=".28"/>
      <rect x="10" y="16" width="16" height="16" rx="2" fill="currentColor" fillOpacity=".18"/>
      <rect x="32" y="16" width="16" height="16" rx="2" fill="currentColor" fillOpacity=".18"/>
      <circle cx="20" cy="57" r="8" fill="currentColor" fillOpacity=".18" stroke="currentColor" strokeOpacity=".3" strokeWidth="1.5"/>
      <circle cx="20" cy="57" r="4" fill="currentColor" fillOpacity=".4"/>
      <circle cx="96" cy="57" r="8" fill="currentColor" fillOpacity=".18" stroke="currentColor" strokeOpacity=".3" strokeWidth="1.5"/>
      <circle cx="96" cy="57" r="4" fill="currentColor" fillOpacity=".4"/>
    </g>
    {/* road */}
    <line x1="0" y1="108" x2="220" y2="108" stroke="currentColor" strokeOpacity=".1" strokeWidth="2" strokeDasharray="14 7"/>
  </svg>
);

const CalendarTruckSVG = ({ className = "w-36 h-20 text-primary" }) => (
  <svg viewBox="0 0 220 110" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* calendar */}
    <rect x="2" y="15" width="80" height="78" rx="6" fill="currentColor" fillOpacity=".08" stroke="currentColor" strokeOpacity=".2" strokeWidth="1.5"/>
    <rect x="2" y="15" width="80" height="22" rx="6" fill="currentColor" fillOpacity=".15"/>
    <rect x="2" y="29" width="80" height="8" fill="currentColor" fillOpacity=".15"/>
    {/* calendar handles */}
    <line x1="24" y1="8" x2="24" y2="22" stroke="currentColor" strokeOpacity=".3" strokeWidth="3" strokeLinecap="round"/>
    <line x1="60" y1="8" x2="60" y2="22" stroke="currentColor" strokeOpacity=".3" strokeWidth="3" strokeLinecap="round"/>
    {/* calendar grid */}
    <rect x="14" y="48" width="12" height="10" rx="2" fill="currentColor" fillOpacity=".15"/>
    <rect x="34" y="48" width="12" height="10" rx="2" fill="currentColor" fillOpacity=".15"/>
    <rect x="54" y="48" width="12" height="10" rx="2" fill="currentColor" fillOpacity=".15"/>
    <rect x="14" y="66" width="12" height="10" rx="2" fill="currentColor" fillOpacity=".1"/>
    <rect x="34" y="66" width="12" height="10" rx="2" fill="currentColor" fillOpacity=".1"/>
    {/* arrow */}
    <line x1="84" y1="55" x2="104" y2="55" stroke="currentColor" strokeOpacity=".2" strokeWidth="1.5" strokeDasharray="4 3"/>
    <path d="M101 51 L107 55 L101 59" stroke="currentColor" strokeOpacity=".3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    {/* truck mini */}
    <g transform="translate(105, 28)">
      <rect x="0" y="5" width="65" height="38" rx="4" fill="currentColor" fillOpacity=".1" stroke="currentColor" strokeOpacity=".22" strokeWidth="1.5"/>
      <path d="M65 18 L65 43 L100 43 L100 29 L86 12 L65 12 Z" fill="currentColor" fillOpacity=".12" stroke="currentColor" strokeOpacity=".25" strokeWidth="1.5"/>
      <path d="M69 22 L69 34 L94 34 L94 29 L82 16 L69 16 Z" fill="currentColor" fillOpacity=".28"/>
      <circle cx="18" cy="50" r="7" fill="currentColor" fillOpacity=".18" stroke="currentColor" strokeOpacity=".3" strokeWidth="1.5"/>
      <circle cx="18" cy="50" r="3.5" fill="currentColor" fillOpacity=".4"/>
      <circle cx="86" cy="50" r="7" fill="currentColor" fillOpacity=".18" stroke="currentColor" strokeOpacity=".3" strokeWidth="1.5"/>
      <circle cx="86" cy="50" r="3.5" fill="currentColor" fillOpacity=".4"/>
    </g>
    <line x1="0" y1="108" x2="220" y2="108" stroke="currentColor" strokeOpacity=".1" strokeWidth="2" strokeDasharray="14 7"/>
  </svg>
);

const BoxesSVG = ({ className = "w-28 h-20 text-primary" }) => (
  <svg viewBox="0 0 160 100" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* big box */}
    <rect x="10" y="30" width="60" height="55" rx="4" fill="currentColor" fillOpacity=".12" stroke="currentColor" strokeOpacity=".25" strokeWidth="1.5"/>
    <line x1="40" y1="30" x2="40" y2="85" stroke="currentColor" strokeOpacity=".15" strokeWidth="1.5"/>
    <line x1="10" y1="58" x2="70" y2="58" stroke="currentColor" strokeOpacity=".15" strokeWidth="1.5"/>
    {/* tape stripe */}
    <rect x="25" y="30" width="30" height="8" rx="2" fill="currentColor" fillOpacity=".25"/>
    {/* small box on top */}
    <rect x="20" y="5" width="42" height="28" rx="3" fill="currentColor" fillOpacity=".1" stroke="currentColor" strokeOpacity=".2" strokeWidth="1.5"/>
    <line x1="41" y1="5" x2="41" y2="33" stroke="currentColor" strokeOpacity=".12" strokeWidth="1.5"/>
    <rect x="29" y="5" width="24" height="7" rx="2" fill="currentColor" fillOpacity=".22"/>
    {/* second box */}
    <rect x="78" y="45" width="72" height="40" rx="4" fill="currentColor" fillOpacity=".1" stroke="currentColor" strokeOpacity=".22" strokeWidth="1.5"/>
    <line x1="114" y1="45" x2="114" y2="85" stroke="currentColor" strokeOpacity=".12" strokeWidth="1.5"/>
    <line x1="78" y1="65" x2="150" y2="65" stroke="currentColor" strokeOpacity=".12" strokeWidth="1.5"/>
    <rect x="92" y="45" width="44" height="8" rx="2" fill="currentColor" fillOpacity=".22"/>
    {/* ground */}
    <line x1="0" y1="95" x2="160" y2="95" stroke="currentColor" strokeOpacity=".1" strokeWidth="2"/>
  </svg>
);

const VARIANTS = {
  quotes:   { svg: DocumentTruckSVG, key: "quotes" },
  missions: { svg: TruckSVG,         key: "missions" },
  calendar: { svg: CalendarTruckSVG, key: "calendar" },
  invoices: { svg: DocumentTruckSVG, key: "invoices" },
  inventory:{ svg: BoxesSVG,         key: "inventory" },
  default:  { svg: TruckSVG,         key: "default" },
};

export default function EmptyState({ type = "default", title, description, action, className = "" }) {
  const { t } = useTranslation();
  const variant = VARIANTS[type] || VARIANTS.default;
  const Illustration = variant.svg;

  return (
    <div className={`flex flex-col items-center justify-center gap-4 py-16 text-center ${className}`}>
      <div className="text-primary opacity-80">
        <Illustration />
      </div>
      <div className="space-y-1 max-w-xs">
        <p className="font-semibold text-base-content text-base" style={{ fontFamily: "'Calistoga', serif" }}>
          {title || t(`empty.${variant.key}Title`)}
        </p>
        <p className="text-sm text-base-content/50">
          {description || t(`empty.${variant.key}Desc`)}
        </p>
      </div>
      {action && <div className="mt-2">{action}</div>}
    </div>
  );
}
